export const deduplicate = <T>(arr: T[]): T[] => {
  return [...new Set(arr).values()];
};
